import React, { useState } from "react";

export default function AccountRow({
  item,
  edit,
  budget,
  categoryList,
  onChangeTargetDate,
  onChange,
  onChangeAmount,
  onSave,
  onRemove,
}) {
  const [editValue, setEditValue] = useState(edit);
  const [budgets, setBudgets] = useState();

  function convertCurrency(number) {
    return new Intl.NumberFormat().format(number);
  }

  function onClickRow() {
    setEditValue(true);
  }

  let options = [];
  if (categoryList && categoryList.length > 0) {
    options.push(<option selected>-</option>);
    categoryList
      .filter((t) => t.TYPE === item.TYPE)
      .forEach((c, i) => {
        options.push(
          <option key={c.ID} value={c.NAME}>
            {c.NAME}
          </option>
        );
      });
  }

  return (
    <div
      className={`w-full items-center ${
        editValue ? "mb-2  sm:items-start" : "cursor-pointer"
      }`}
      key={`${item.ID}`}
      onClick={() => onClickRow()}
    >
      {editValue ? (
        <div className="grid grid-cols-5 truncate">
          <input
            type="date"
            className="border-gray-400 h-6"
            value={item.TARGET_DATE}
            onChange={onChangeTargetDate}
          />
          <select value={item.CATEGORY}>{options}</select>
          <input
            type="text"
            className="border-gray-400 truncate"
            value={item.DETAIL}
            onChange={onChange}
          />
          <input
            type="number"
            className="border-gray-400"
            value={item.AMOUNT}
            onChange={onChangeAmount}
          />
          <button className="w-10 border rounded ml-2" onClick={onSave}>
            Edit
          </button>
          <button className="w-6 h-6" onClick={onRemove}>
            -
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-5 truncate">
          <span className="truncate">{item.TARGET_DATE.substring(0, 10)}</span>
          <span className="truncate col-span-2">
            {item.CATEGORY}
            {item.DETAIL ? `(${item.DETAIL})` : null}
          </span>
          <span>{convertCurrency(item.AMOUNT)}</span>
          <span>{convertCurrency(budget - item.AMOUNT)}</span>
        </div>
      )}
    </div>
  );
}
